import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import './DocumentLayout.scss'; // We'll create this CSS file
import html2pdf from 'html2pdf.js';
import { getAPI } from '../../apis/backend/apiNode';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

function DocumentLayout() {
	const { model, id } = useParams();
	const [isLoading, setIsLoading] = useState(true);
	const [pdfUrl, setPdfUrl] = useState();
	const iframeRef = useRef(null);

	useEffect(() => {
		// only fetch if model and id exist
		if (!model || !id) return;

		let isMounted = true; // avoid setting state after unmount

		const fetchHTML = async () => {
			try {
				const res = await getAPI('documentLayouts', `/download/${model}/${id}`);
				if (isMounted && iframeRef.current) {
					iframeRef.current.srcdoc = res; // set iframe content
					html2canvas(res, { scale: 2 })
						.then((canvas) => {
							const imgData = canvas.toDataURL('image/png');
							const pdf = new jsPDF('p', 'mm', 'a4');
							const pdfWidth = pdf.internal.pageSize.getWidth();
							const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
							pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
							const blob = pdf.output('blob');
							const url = URL.createObjectURL(blob);
							setPdfUrl(url);
							// document.body.removeChild(container);
						})
						.catch((error) => {
							console.error('Local PDF generation error:', error);
						});
				}
			} catch (err) {
				console.error('Error fetching HTML:', err);
			}
		};

		fetchHTML();

		return () => {
			isMounted = false; // cleanup
		};
	}, [model, id]);
	const handlePrint = () => {
		const iframe = iframeRef.current;
		if (!iframe) return;

		const doc = iframe.contentDocument || iframe.contentWindow.document;

		// Open a new window with full HTML (head + body)
		const printWindow = window.open('', '_blank');
		if (!printWindow) return;

		printWindow.document.open();
		printWindow.document.write(`
	<html>
	  <head>
		<title>Print Document</title>
		${doc.head.innerHTML} <!-- include all styles -->
	  </head>
	  <body>
		${doc.body.innerHTML} <!-- include content -->
	  </body>
	</html>
  `);
		printWindow.document.close();

		// Give the browser a tiny delay to apply styles
		setTimeout(() => {
			printWindow.focus();
			printWindow.print();
			printWindow.close();
		}, 200);
	};

	const handleDownload = () => {
		const iframe = iframeRef.current;
		const doc = iframe.contentDocument || iframe.contentWindow.document;

		// Combine head <style> + body content
		const htmlContent = `
	<html>
	  <head>${doc.head.innerHTML}</head>
	  <body>${doc.body.innerHTML}</body>
	</html>
  `;
		html2canvas(htmlContent, { scale: 2 })
			.then((canvas) => {
				const imgData = canvas.toDataURL('image/png');
				const pdf = new jsPDF('p', 'mm', 'a4');
				const pdfWidth = pdf.internal.pageSize.getWidth();
				const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
				pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
				const blob = pdf.output('blob');
				const url = URL.createObjectURL(blob);
				setPdfUrl(url);
				// document.body.removeChild(container);
			})
			.catch((error) => {
				console.error('Local PDF generation error:', error);
			});

		// html2pdf()
		// 	.from(htmlContent)
		// 	.set({
		// 		filename: `${model}-${id}.pdf`,
		// 		html2canvas: { scale: 2 },
		// 		jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
		// 	})
		// 	.save();
	};

	const handleIframeLoad = () => {
		setIsLoading(false);
	};

	return (
		<div className='document-viewer-container w-100'>
			{/* Header with controls */}
			<div className='pdf-toolbar'>
				<div className='toolbar-left'>
					<span className='document-title'>Document PDF</span>
				</div>
				<div className='toolbar-right'>
					<button
						className='toolbar-btn'
						onClick={handleDownload}
						title='Enregistrer le document'>
						<svg width='16' height='16' viewBox='0 0 24 24' fill='currentColor'>
							<path d='M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z' />
						</svg>
						Enregistrer
					</button>
					<button
						className='toolbar-btn'
						onClick={handlePrint}
						title='Imprimer le document'>
						<svg width='16' height='16' viewBox='0 0 24 24' fill='currentColor'>
							<path d='M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z' />
						</svg>
						Imprimer
					</button>
				</div>
			</div>

			{/* Loading indicator */}
			{isLoading && (
				<div className='loading-container'>
					<div className='loading-spinner'></div>
					<p>Chargement du document...</p>
				</div>
			)}

			{/* PDF Viewer */}
			<div className='pdf-viewer py-2'>
				<iframe
					ref={iframeRef}
					src={pdfUrl}
					style={{
						width: '100%',
						height: 'calc(100vh - 60px)',
						border: 'none',
						display: 'block',
					}}
					title={`PDF - ${model} - ${id}`}
				/>
				<iframe
					ref={iframeRef}
					style={{ width: '100%', height: '100vh' }}
					onLoad={handleIframeLoad}
					title='Document Layout'
				/>

				{/* <iframe
					src={`http://localhost:3000/coreService/document-layouts/download/${model}/${id}`}
					style={{
						width: '100%',
						height: '100%',
						border: 'none',
						display: isLoading ? 'none' : 'block',
					}}
					onLoad={handleIframeLoad}
					title='Document Layout'
				/> */}
			</div>
		</div>
	);
}

export default DocumentLayout;
